import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from '../../../../src/client/App'

import createAuthRequiredPage from "./auth/pages/createAuthRequiredPage"

import LoginPage from '../../../../src/auth/LoginPage'
import { Signup as SignupPage } from '../../../../src/auth/SignupPage'
import { LegacySignup as LegacySignupPage } from '../../../../src/auth/LegacySignupPage'
import { RequestPasswordResetPage } from '../../../../src/auth/email-and-pass/RequestPasswordResetPage'
import { PasswordResetPage } from '../../../../src/auth/email-and-pass/PasswordResetPage'
import { EmailVerificationPage } from '../../../../src/auth/email-and-pass/EmailVerificationPage'
import AdminOnboardingPage from '../../../../src/admin/onboarding/OnboardingPage'
import AdminOptimizationDashboardPage from '../../../../src/admin/dashboards/optimization/AdminOptimizationDashboardPage'
import AdminOptimizationTestingPage from '../../../../src/admin/dashboards/optimization/AdminOptimizationTestingPage'
import AdminGengageSettingsPage from '../../../../src/admin/dashboards/GengageSettingsPage'
import AdminDashboardPage from '../../../../src/admin/dashboards/AdminDashboardPage'
import AdminProductsPage from '../../../../src/admin/dashboards/AdminProductsPage'
import AdminJobsPage from '../../../../src/admin/dashboards/AdminJobsPage'
import AdminEnrichmentConfigPage from '../../../../src/admin/dashboards/AdminEnrichmentConfigPage'
import AdminDebugPage from '../../../../src/admin/debug/AdminDebugPage'
import AdminUsersCollectionsPage from '../../../../src/admin/debug/AdminUsersCollectionsPage'
import AdminUsagePage from '../../../../src/admin/dashboards/AdminUsagePage'
import AdminBillingPage from '../../../../src/admin/dashboards/AdminBillingPage'
import AdminUpgradePlanPage from '../../../../src/admin/dashboards/AdminUpgradePlanPage'
import NotFoundPage from '../../../../src/404'
import BillingTestPage from '../../../../src/admin/dashboards/BillingTestPage'
import AuthSucceededPage from '../../../../src/auth/AuthSucceededPage'

import { OAuthCallbackPage } from "./auth/pages/OAuthCallback"

import { DefaultRootErrorBoundary } from './components/DefaultRootErrorBoundary'

import { routes } from 'wasp/client/router'

export const routeNameToRouteComponent = {
  LandingPageRoute: createAuthRequiredPage(AdminDashboardPage),
  LoginRoute: LoginPage,
  SignupRoute: SignupPage,
  LegacySignupRoute: LegacySignupPage,
  RequestPasswordResetRoute: RequestPasswordResetPage,
  PasswordResetRoute: PasswordResetPage,
  EmailVerificationRoute: EmailVerificationPage,
  AdminRoute: createAuthRequiredPage(AdminDashboardPage),
  AdminOnboardingRoute: createAuthRequiredPage(AdminOnboardingPage),
  AdminOptimizationDashboardRoute: createAuthRequiredPage(AdminOptimizationDashboardPage),
  AdminOptimizationTestingRoute: createAuthRequiredPage(AdminOptimizationTestingPage),
  AdminGengageSettingsRoute: createAuthRequiredPage(AdminGengageSettingsPage),
  AdminDashboardRoute: createAuthRequiredPage(AdminDashboardPage),
  AdminProductsPageRoute: createAuthRequiredPage(AdminProductsPage),
  AdminJobsPageRoute: createAuthRequiredPage(AdminJobsPage),
  AdminEnrichmentConfigPageRoute: createAuthRequiredPage(AdminEnrichmentConfigPage),
  AdminDebugRoute: createAuthRequiredPage(AdminDebugPage),
  AdminUsersCollectionsRoute: createAuthRequiredPage(AdminUsersCollectionsPage),
  AdminUsageRoute: createAuthRequiredPage(AdminUsagePage),
  AdminBillingRoute: createAuthRequiredPage(AdminBillingPage),
  AdminUpgradePlanRoute: createAuthRequiredPage(AdminUpgradePlanPage),
  NotFoundRoute: NotFoundPage,
  BillinTestRoute: createAuthRequiredPage(BillingTestPage),
  AuthSucceededRoute: createAuthRequiredPage(AuthSucceededPage),
} as const;

const waspDefinedRoutes = [
  {
    path: "/oauth/callback",
    Component: OAuthCallbackPage,
  },
]
const userDefinedRoutes = Object.entries(routes).map(([routeKey, route]) => {
  return {
    path: route.to,
    Component: routeNameToRouteComponent[routeKey],
  }
})

const browserRouter = createBrowserRouter([{
  path: '/',
  element: <App />,
  ErrorBoundary: DefaultRootErrorBoundary,
  children: [
    ...waspDefinedRoutes,
    ...userDefinedRoutes,
  ],
}])

export const router = <RouterProvider router={browserRouter} />
